import { ReactNode, memo } from 'react';
import { Navigate } from 'react-router-dom';
import authorityGuard from '../../utils/authorityGuard';

interface AuthorityGuardI {
  authority?: string[];
  children?: ReactNode;
}

function AuthorityGuard(props: AuthorityGuardI) {
  const { authority = [], children } = props;

  const roleMatched = authorityGuard(authority);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return roleMatched ? <>{children}</> : <Navigate to="/error-forbidden" />;
}

export default memo(AuthorityGuard);
